import { render, staticRenderFns } from "./Revocation.vue?vue&type=template&id=6a986809&"
import script from "./Revocation.vue?vue&type=script&lang=js&"
export * from "./Revocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports